import React from 'react';
import { createPortal } from 'react-dom';
import { getSmoothStepPath, Position } from 'reactflow';
import { useRecoilValue } from 'recoil';
import styled, { css } from 'styled-components';
import interactions from '~/components/page/Automation/v2/state/interactions';
import { EDGE_BORDER_RADIUS } from '../edgeTypes/components/BaseEdge';

const PASTE_CONTAINER_TARGET_OFFSET_Y = 24;

const CopyHoverPreviewEdge: React.FCC = () => {
  const interaction = useRecoilValue(interactions);
  if (interaction?.type !== 'copyAction') return null;

  const preview = interaction.copyHoverPreview;

  const renderLayer = document.querySelector('.react-flow__edges > g');
  if (!renderLayer) return null;

  const from = preview.from;
  const to = preview.to;
  if (!from || !to) return null;

  const d = getSmoothStepPath({
    sourceX: from.x,
    sourceY: from.y,
    sourcePosition: Position.Bottom,
    targetX: to.x,
    // Offset the endpoint so the arrow head doesn't sit under the label/button.
    targetY: to.y - PASTE_CONTAINER_TARGET_OFFSET_Y,
    targetPosition: Position.Top,
    borderRadius: EDGE_BORDER_RADIUS,
  })[0];

  return createPortal(
    <g id="portal-copy-hover-preview-arrow">
      <Path className="react-flow__edge-path" d={d} markerEnd="url(#arrow)" />
    </g>,
    renderLayer,
  );
};

const Path = styled.path(
  ({ theme }) => css`
    /* stroke: ${theme.color('secondary')}; */
    stroke-width: 3;
    stroke-dasharray: 6 5;
    fill: none;
    opacity: 0.95;
    pointer-events: none;
  `,
);

export default CopyHoverPreviewEdge;
